import Ajax from './Ajax.js'

const TreeType = {
  getTreeTypes: (id = null) => {
    let uri = id !== null
      ? '/tree-types' + '/' + id
      : '/tree-types'
    return Ajax.get(uri)
  },
  getTreeTypesByRef: (ref) => {
    let uri = `/tree-types?reference_eq=${ref}`;
    return Ajax.get(uri)
  },

  postTreeTypes: (params) => {
    const payload = params && params.data ? params : { data: params }
    return Ajax.post('/tree-types', payload)
  },

  putTreeTypes: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/tree-types/' + id, payload)
  },

  delTreeTypes: (id) => {
    return Ajax.delete('/tree-types/' + id)
  }
}

export default TreeType
